module.exports = "<p>\n  quick-sidebar works!\n</p>\n"